var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveB({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 23,
    viewBox: "0 0 42 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.0913086C2.46243 0.0913086 0 2.55374 0 5.59131V16.5913C0 19.6288 2.46243 22.0913 5.5 22.0913H35.75C38.7875 22.0913 41.25 19.6288 41.25 16.5913V5.59131C41.25 2.55374 38.7875 0.0913086 35.75 0.0913086H5.5ZM2.75 5.59131C2.75 4.07248 3.98122 2.84131 5.5 2.84131H35.75C37.2688 2.84131 38.5 4.07248 38.5 5.59131V16.5913C38.5 18.1101 37.2688 19.3413 35.75 19.3413H5.5C3.98122 19.3413 2.75 18.1101 2.75 16.5913V5.59131ZM9.471 7.51631H6.875V15.2163H12.947V13.2033H9.471V7.51631ZM17.1401 7.51631H14.5441V15.2163H17.1401V7.51631ZM27.4978 7.51631L24.2418 15.2163H21.6898L18.4338 7.51631H21.2278L23.0648 12.0153L24.9458 7.51631H27.4978ZM35.0382 15.2163V13.2583H31.188V12.2463H34.444V10.3763H31.188V9.47431H34.8952V7.51631H28.6362V15.2163H35.0382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveB);
export default __webpack_public_path__ + "static/media/liveB.6de5ce164d0ce80de8b84bbb4b47ab75.svg";
export { ForwardRef as ReactComponent };